import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModal, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { SharedModule } from "../../../shared/shared.module";

@Component({
  selector: 'app-index-camercode',
  standalone: true,
  imports: [CommonModule, CarouselModule, NgbModule, YouTubePlayerModule, ScrollToModule, FeatherModule, SharedModule],
  templateUrl: './index-camercode.component.html',
  styleUrls: ['./index-camercode.component.css']
})

/**
 * Camercode Component
 */
export class IndexCamercodeComponent implements OnInit {

    // Set Topbar Option
  Menuoption = 'camercode';
  Settingicon = true
  footerVariant = 'footer-five';
  navClass = "nav-light";

  constructor(private modalService: NgbModal, config: NgbCarouselConfig) {
    config.interval = 2000;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = false;
  }

  customOptions: OwlOptions = {
    // loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    dots: false,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      900: {
        items: 1
      }
    },
    nav: false
  };


  /**
   * Client Testimonial Data
   */
  testimonialData = [
    {
      profile: "assets/images/client/01.jpg",
      name: "Marc Dubois",
      designation: "Directeur IT, TechCorp France",
      message: `"L'accompagnement de cette ESN dans notre migration Cloud a été exceptionnel. Leur expertise DevOps nous a permis de réduire nos temps de déploiement de 70% tout en améliorant la stabilité de nos applications critiques."`
    },
    {
      profile: "assets/images/client/02.jpg",
      name: "Sophie Laurent",
      designation: "CTO, InnoTech Solutions",
      message: `"Grâce à leur solution d'automatisation IA, nous avons optimisé nos processus de traitement des données. L'équipe a su comprendre nos besoins métier et proposer une architecture microservices parfaitement adaptée."`
    },
    {
      profile: "assets/images/client/03.jpg",
      name: "Jean-Pierre Moreau",
      designation: "Responsable Digital, Groupe Financier Lyon",
      message: `"Leur approche Infrastructure as Code nous a révolutionné. La mise en place de containers Kubernetes et du monitoring 24/7 a considérablement renforcé notre sécurité et notre réactivité face aux incidents."`
    },
    {
      profile: "assets/images/client/04.jpg",
      name: "Marie Chen",
      designation: "Directrice Innovation, StartUp Tech Paris",
      message: `"L'intégration de solutions IA développées par cette ESN a transformé notre analyse client. Leur expertise en architectures Cloud nous permet désormais de scaler rapidement selon notre croissance."`
    },
    {
      profile: "assets/images/client/05.jpg",
      name: "Philippe Roux",
      designation: "Manager IT, Industrie 4.0 Marseille",
      message: `"Le support technique 24/7 et la maintenance proactive nous ont évité de nombreuses interruptions. Leur approche DevOps a modernisé notre chaîne CI/CD et amélioré la qualité de nos livraisons."`
    },
    {
      profile: "assets/images/client/06.jpg",
      name: "Isabelle Martin",
      designation: "Directrice Systèmes, E-commerce Bordeaux",
      message: `"La transformation digitale menée par cette ESN a boosté nos performances e-commerce. Leur expertise en sécurité Cloud et automatisation nous a permis de gérer des pics de charge importants en toute sérénité."`
    }
  ];

  /**
   * Blog Data
   */
  blogData = [
    {
      image: "assets/images/blog/01.jpg",
      title: "L'avenir du Cloud Computing : tendances et innovations",
      description: "Découvrez les dernières tendances du Cloud Computing et comment les architectures hybrides [...]",
      like: "45",
      message: "12",
      name: "Pierre Dubois",
      date: "15 Janvier, 2026"
    },
    {
      image: "assets/images/blog/02.jpg",
      title: "Automatisation des processus avec l'IA : guide complet.",
      description: "Explorez comment l'intelligence artificielle révolutionne l'automatisation des workflows métier pour [...]",
      like: "38",
      message: "09",
      name: "Marie Laurent",
      date: "12 Janvier, 2026"
    },
    {
      image: "assets/images/blog/03.jpg",
      title: "Sécurité informatique : les meilleures pratiques",
      description: "Apprenez les stratégies essentielles pour protéger vos systèmes informatiques contre les cybermenaces émergentes.",
      like: "52",
      message: "15",
      name: "Jean Moreau",
      date: "10 Janvier, 2026"
    }
  ];

  ngOnInit(): void {
  }

  /**
    * Open modal for show the video
    * @param content content of modal
    */
  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }

  /**
  * Open modal for show the video
  */
  openModal(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }

    /**
   * Window scroll method
   */
  // tslint:disable-next-line: typedef
  windowScroll() {
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      document.getElementById('topnav').classList.add('nav-sticky');
    } else {
      document.getElementById('topnav').classList.remove('nav-sticky');
    }

    if (document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100) {
      document.getElementById('back-to-top').style.display = 'inline';
    } else {
      document.getElementById('back-to-top').style.display = 'none';
    }
  }

}
